import { useReactNavigationDevTools } from '@dev-plugins/react-navigation';
import { useNavigationContainerRef } from 'expo-router';
import React from 'react';

import type { ContainerComponent } from '../../types/Common';

const RegisterRoutingInstrumentation: ContainerComponent = ({ children }) => {
    const navigationRef = useNavigationContainerRef();

    // For development builds, add debugging for Expo Router: https://docs.expo.dev/debugging/devtools-plugins/#react-navigation.
    useReactNavigationDevTools(navigationRef);

    return <>{children}</>;
};

export default RegisterRoutingInstrumentation;
